import React, { useEffect } from "react";

const HeadMetaTags = (props) => {
  const { currentPath, title, description, ogTitle, ogImage, children } = props;
  let ogTitleMeta = document.querySelector('meta[property="og:title"]');
  let ogDescMeta = document.querySelector('meta[property="og:description"]');
  let ogImageMeta = document.querySelector('meta[property="og:image"]');
  let ogUrlMeta = document.querySelector('meta[property="og:url"]');
  let ogTypeMeta = document.querySelector('meta[property="og:type"]');

  useEffect(() => {
    const isMetaNoFollow =
      process.env.REACT_APP_NOFOLLOW === "true" ? true : false;

    if (ogTitle) ogTitleMeta.setAttribute("content", ogTitle);
    if (description) ogDescMeta.setAttribute("content", description);
    if (ogImage) ogImageMeta.setAttribute("content", ogImage);
    if (currentPath) ogUrlMeta.setAttribute("content", currentPath);
    ogTypeMeta.setAttribute("content", "website");

    if (isMetaNoFollow) {
      const metaNoFollow = document.createElement("meta");
      metaNoFollow.setAttribute("name", "robots");
      metaNoFollow.setAttribute("content", "noIndex, nofollow");
      document.head.appendChild(metaNoFollow);
      // console.log(
      //   "noIndex/noFollow: ",
      //   isMetaNoFollow
      //   // document.querySelector('link[rel="icon"]').href
      // );
    }

    document.title = title || "Roommates Made Simple - Post a Room for Free!";
    document.description =
      description ||
      "Collect rent, split bills, assign chores, and more. It's property management by the room. Get started for free. No credit card required.";
  }, [title, description]);

  return (
    <>
      {/* 
      Use {children} as a prop if you want to enclose all parent content. 
      Children will be anything encapsulated within component (change from self closing tag) 
      */}
    </>
  );
};

export default HeadMetaTags;
